import capitalize from 'lodash/capitalize';
import classnames from 'classnames';
import { Button, Modal } from 'components/common';
import { billing, format, useResponsiveWidth } from 'libs';

interface RetentionOfferAddon {
  eligible_discount: { percent_off?: number };
  price: {
    frequency?: string;
    name?: string;
    price?: number;
  };
}

interface RetentionOfferProps {
  addon: RetentionOfferAddon;
  onClick: () => void;
  onHideModal: () => void;
  showModal: boolean;
}

const RetentionOffer = ({ addon, onClick, onHideModal, showModal }: RetentionOfferProps) => {
  const { isMinSm } = useResponsiveWidth();

  return (
    <Modal centered onHide={onHideModal} show={showModal}>
      <div className="d-flex flex-column justify-content-center align-items-center mx-4 my-2">
        <img alt="gift box with sale tag" src="/images/gift-box-with-sale-tag.svg" />
        <div className="lh-1 text-center" data-testid="subscriptions-retention-offer-modal">
          <h3 className="fw-bold my-4 text-1_5" data-testid="subscriptions-retention-offer-modal-title">
            Special Offer!
          </h3>
          <div className="fw-bold mb-4">
            <div className="text-2_25 mb-2">
              Get {addon.eligible_discount.percent_off}% off {addon.price.name}
            </div>
            <div className="text-1_25">available for one month</div>
          </div>
          <div className="fw-bold mb-4">
            <div className="mb-1 text-line-through text-heading-light text-1_25">
              ${addon.price.price! / 100} / {capitalize(addon.price.frequency)}
            </div>
            <div className="text-1_5">
              {format.currency(billing.discount(addon.price, addon.eligible_discount) / 100)}
            </div>
          </div>
          <div>
            <div>
              <div className={classnames({ 'd-inline-block': isMinSm, 'col-md-12 mb-2': !isMinSm })}>
                <Button
                  onClick={onClick}
                  testId="subscriptions-retention-offer-modal-confirm-button"
                  text="bold"
                  variant="primary-dark"
                  width={isMinSm ? 'content' : 'block'}
                >
                  Get {addon.eligible_discount.percent_off}% discount
                </Button>
              </div>
              <div className={classnames({ 'd-inline-block ms-2': isMinSm, 'col-md-12': !isMinSm })}>
                <Button
                  onClick={onHideModal}
                  testId="subscriptions-retention-offer-modal-cancel-button"
                  text="bold"
                  variant="border-danger"
                  width={isMinSm ? 'content' : 'block'}
                >
                  No, thanks
                </Button>
              </div>
              <div className="lh-sm mt-4 text-0_75">
                If you accept this offer, you&apos;ll be charged the discounted price in your next billing cycle, and
                the regular full price in following cycles. If you have any questions, feel free to contact our support
                team.
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RetentionOffer;
